export default __webpack_public_path__ + "static/media/kohut-1.dcd59465.jpg";